<template>
  <div class="page">
    <a-card :bordered="false" :bodyStyle="{paddingTop:'10px'}">
      <Breadcrumb routeName="PcWeb" :toName="title" cneterName="轮播图" goPathName="PC网站"></Breadcrumb>
      <a-form-model
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        :label-col="currentFormLayout.labelCol"
        :wrapper-col="currentFormLayout.wrapperCol">
        <a-form-model-item label="内容类型">
          <a-radio-group v-model="ruleForm.modularContentType" @change="onChangeType">
            <a-radio :value="0">商品</a-radio>
            <a-radio :value="1">链接</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="轮播图片" prop="modularDetailImg">
          <a-upload
            name="file"
            accept=".png,.jpg,.jpeg"
            :multiple="false"
            :action="uploadFileUrl"
            :fileList="fileList"
            :limit="1"
            @change="onUploadChange"
            :before-upload="handleBefore"
          >
            <a-button>
              <a-icon type="upload"/>
              上传文件
            </a-button>
            <span class="image-hint">温馨提示：图片建议上传尺寸为1920px*630px，格式.jpg、.png、.jpeg</span>
          </a-upload>
        </a-form-model-item>
        <a-form-model-item label="标题" prop="modularDetailTitle">
          <a-input placeholder="请输入" v-model="ruleForm.modularDetailTitle" style="max-width:500px" :maxLength="30"/>
        </a-form-model-item>
        <a-form-model-item label="投放时间" prop="modularDetailStartTime">
          <a-range-picker
            @change="onDateChange"
            show-time
            :format="formatDate"
            v-model="ruleForm.buildTime"
            :disabledDate="disabledDate"/>
        </a-form-model-item>
        <a-form-model-item label="关联商品" v-if="ruleForm.modularContentType == 0" prop="proId">
          <a-button @click="showModel" type="primary">选择</a-button>
          <span v-if="ruleForm.proId">&nbsp;&nbsp;商品ID：{{ ruleForm.proId }}</span>
        </a-form-model-item>
        <a-form-model-item label="链接" v-if="ruleForm.modularContentType == 1" prop="interlinkage">
          <a-input v-model="ruleForm.interlinkage" placeholder="小程序仅支持安全域名下的链接" style="max-width:500px"/>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
          <a-button type="primary" @click="handleSubmit" :loading="submitLoading">确定</a-button>
          <a-button style="margin-left: 3%;" @click="goReset">重置</a-button>
          <a-button style="margin-left: 3%;" @click="goBack">取消</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-card>
    <ProductPopupView :visible="visiblePopup" @change="changeSelectPro" @cancel="handleCancel"></ProductPopupView>
  </div>
</template>

<script>
import Breadcrumb from '@/customComponents/Breadcrumb/Breadcrumb'
import ruleFormMixins from '@/utils/mixins/ruleFormMixins'
import ProductPopupView from '@/customComponents/productPopupView/productPopupView'
import moment from 'moment'
import { getQueryString } from '@/utils/common'

export default {
  name: 'AddSlideShow',
  components: {
    Breadcrumb,
    ProductPopupView
  },
  mixins: [ruleFormMixins],
  data() {
    return {
      moment,
      ruleForm: {
        modularContentType: 0,
        modularDetailImg: undefined,
        modularDetailTitle: '',
        modularDetailStartTime: undefined,
        modularDetailEndTime: undefined,
        proId: '',
        interlinkage: '',
        buildTime: []
      },
      homeModularId: '',
      modularDetailId: 0,
      rules: {
        modularDetailImg: [{ required: true, message: '请上传图片', trigger: 'blur' }],
        modularDetailTitle: [
          { required: true, message: '请输入标题', trigger: 'blur' },
          { min: 1, max: 30, message: '标题30字内', trigger: 'blur' }
        ],
        modularDetailStartTime: [{ required: true, message: '请选择起止日期', trigger: 'blur' }],
        proId: [{ required: true, message: '请选择商品', trigger: 'blur' }],
        interlinkage: [
          { required: true, message: '请输入链接', trigger: 'blur' },
          {
            pattern: /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/,
            message: '请输入正确网络链接',
            trigger: 'blur'
          }
        ]
      },
      fileList: [],
      submitLoading: false,
      formatDate: 'YYYY-MM-DD HH:mm:ss',
      disabledDate(current) {
        return current && current < moment().startOf('day')
      },
      uploadFileUrl: '',
      visiblePopup: false,
      title: '添加新内容'
    }
  },
  mounted() {
    let appConfig = this.getAppConfig()
    this.uploadFileUrl = appConfig.baseUrl + (appConfig.isDev ? '/' : '') + 'base/upload'
  },
  activated() {
    this.fileList = []
    this.homeModularId = this.$route.query.homeModularId
    this.modularDetailId = this.$route.query.modularDetailId
    this.title = this.modularDetailId ? '编辑' : '添加新内容'
    this.goReset()
    this.getNewData()
  },
  methods: {
    // 重新获取数据
    onChangeType() {
      this.ruleForm.proId = ''
      this.ruleForm.interlinkage = ''
    },
    getNewData() {
      if (this.modularDetailId) {
        this.getHomeModularDetail()
      } else {
        this.goReset()
        this.ruleForm.modularDetailStartTime = this.getDateHelper().getCurrentFormatDate('YYYY-MM-DD HH:mm:ss')
        this.ruleForm.modularDetailEndTime = this.getDateHelper().formatDate(moment().add(30, 'days'), 'YYYY-MM-DD HH:mm:ss')
        this.ruleForm.buildTime = [moment(new Date(), this.dateFormat), moment(moment().add(30, 'days'), this.dateFormat)]
      }
    },
    // 获取数据
    getHomeModularDetail() {
      this.getHttpServices().getUserService().post('homepage/recommend/get/modularDetail', {
        homeModularDetailId: this.modularDetailId
      }).then(res => {
        this.getLogUtils().logWithTag('==getHomeModularDetail==', res)
        if (res.modularContentType == 0) {
          this.type = 0
          this.ruleForm.proId = res.modularDetailLinked
        } else if (res.modularContentType == 1) {
          this.ruleForm.type = 1
          this.ruleForm.interlinkage = res.modularDetailLinked
        }
        this.fileList = [
          {
            uid: '-1',
            name: res.modularDetailImg,
            status: 'done',
            url: res.modularDetailImg
          }
        ]
        this.ruleForm.modularDetailImg = res.modularDetailImg
        this.ruleForm.modularDetailStartTime = res.modularDetailStartTime
        this.ruleForm.modularDetailEndTime = res.modularDetailEndTime
        this.ruleForm.modularContentType = res.modularContentType
        this.ruleForm.modularDetailTitle = res.modularDetailTitle
        this.ruleForm.buildTime = this.getDateHelper().getDateMoments(res.modularDetailStartTime, res.modularDetailEndTime)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    goReset() {
      this.$refs.ruleForm.resetFields()
    },
    showModel() {
      this.visiblePopup = true
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.handleOk()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    handleOk() {
      let params = {}
      params.homeModularId = this.homeModularId
      params.modularContentType = this.ruleForm.modularContentType
      params.modularDetailEndTime = this.ruleForm.modularDetailEndTime
      params.modularDetailId = this.modularDetailId
      params.modularDetailImg = this.ruleForm.modularDetailImg
      params.modularDetailLinked = this.ruleForm.modularContentType == 0 ? this.ruleForm.proId : this.ruleForm.interlinkage
      if (this.ruleForm.modularContentType == 0) {
        params.modularDetailParamLinked = null
        params.modularDetailParamLinkedType = null
      } else {
        let url = new URL(this.ruleForm.interlinkage)
        if (getQueryString('subjectMerchantId', url) != null) {
          params.modularDetailParamLinked = getQueryString('subjectMerchantId', url)
          params.modularDetailParamLinkedType = 2
        } else if (getQueryString('proId', url) != null) {
          params.modularDetailParamLinked = getQueryString('proId', url)
          params.modularDetailParamLinkedType = 1
        } else {
          params.modularDetailParamLinked = null
          params.modularDetailParamLinkedType = null
        }
      }
      params.modularDetailStartTime = this.ruleForm.modularDetailStartTime
      params.modularDetailTitle = this.ruleForm.modularDetailTitle
      this.getLogUtils().logWithTag('保存表单数据', params)
      this.submitLoading = true
      this.getHttpServices().getUserService().post('homepage/recommend/save/modularDetail', params)
        .then(res => {
          this.$message.success('内容保存成功')
          this.goBack()
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },

    goBack() {
      this.$router.go(-1)
    },
    changeSelectPro(item) {
      let modularDetailTitle = this.ruleForm.modularDetailTitle
      let modularDetailImg = this.ruleForm.modularDetailImg
      if (this.ruleForm.proId && this.ruleForm.proId != item.proId) {
        this.ruleForm.modularDetailTitle = item.proName.substr(0, 30)
        this.fileList = [
          {
            uid: '-1',
            name: item.proImg,
            status: 'done',
            url: item.proImg
          }
        ]
        this.ruleForm.modularDetailImg = item.proImg
      }
      if (!modularDetailTitle) {
        this.ruleForm.modularDetailTitle = item.proName.substr(0, 30)
      }
      if (!modularDetailImg) {
        this.fileList = [
          {
            uid: '-1',
            name: item.proImg,
            status: 'done',
            url: item.proImg
          }
        ]
        this.ruleForm.modularDetailImg = item.proImg
      }
      this.ruleForm.proId = item.proId
      this.handleCancel()
      console.error('this.ruleForm', this.ruleForm)
    },
    handleCancel() {
      this.visiblePopup = false
    },
    onDateChange(dates, dateStrArr) {
      this.ruleForm.modularDetailStartTime = dateStrArr[0]//出游开始日期
      this.ruleForm.modularDetailEndTime = dateStrArr[1]//出游结束日期
    },
    onUploadChange(file) {
      if (file.file.status != 'removed') {
        this.fileList = [...file.fileList]
        this.fileList = this.fileList.slice(-1)
        this.fileList.forEach(file => {
          // 因为只有一个，所以可以用
          if (file.response) {
            this.ruleForm.modularDetailImg = file.response.data
          }
        })
      } else {
        this.fileList = []
        this.modularDetailImg = ''
        setTimeout(() => {
          this.ruleForm.modularDetailImg = undefined
        }, 300)
      }
      this.getLogUtils().errorWithTag('上传的图片', this.ruleForm.modularDetailImg)
    },
    handleBefore(file) {
      // 限制图片 格式、size、分辨率
      const isJPG = file.type === 'image/jpg'
      const isJPEG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      if (!(isJPG || isJPEG || isGIF || isPNG)) {
        this.$message.error('上传图片的格式不正确，不是JPG、JPEG、PNG')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('上传的文件不能大于2M!')
      }
      return true
    }
  }
}
</script>

<style lang="less" scoped>
.image-hint {
  margin-left: 20px;
}
</style>